// Generated by purs version 0.14.4
var Key = function (x) {
    return x;
};
var Storage = (function () {
    function Storage(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Storage.create = function (value0) {
        return function (value1) {
            return new Storage(value0, value1);
        };
    };
    return Storage;
})();
var setJSONItem = function (dictEncode) {
    return function (v) {
        return v.value1(dictEncode);
    };
};
var getJSONItem = function (dictDecode) {
    return function (v) {
        return v.value0(dictDecode);
    };
};
export {
    Storage,
    Key,
    getJSONItem,
    setJSONItem
};
//# sourceMappingURL=index.js.map
